import { FieldArray } from 'formik';
import React from 'react';

import RadioGroup from '../../../../../../components/Form/Fields/RadioGroup';
import QualifyingRadioGroup from '../../../../../../components/Form/Fields/QualifyingRadioGroup';
import FormRow from '../../../../../../components/Form/Fields/FormRow';
import Address from '../../../../../../components/Form/Fields/Address';
import analytics from '../../../../../../analytics';
import { CHECK_SERVICEABILITY } from '../../../../../../queries';

import { StepOneProps, StepOneState } from './StepOne.types';
import QualifyingRadioImageGroupField from '../../../../../../components/Form/Fields/QualifyingRadioImageGroupField';

class StepOne extends React.Component<StepOneProps, StepOneState> {
  static getDerivedStateFromProps(nextProps: StepOneProps, prevState: StepOneState): Partial<StepOneState | null> {
    if (nextProps.asyncFetching !== prevState.asyncFetching) {
      return { asyncFetching: nextProps.asyncFetching };
    } else return null;
  }

  constructor(props: StepOneProps) {
    super(props);

    this.state = {
      asyncFetching: props.asyncFetching
    };
  }

  componentDidUpdate(prevProps: StepOneProps, prevState: StepOneState) {
    const { asyncFetching } = this.state;

    if (prevProps.asyncFetching !== prevState.asyncFetching) {
      this.setState({
        asyncFetching
      });
    }
  }

  componentDidMount() {
    analytics.pageLoad('step1');
  }

  render(): JSX.Element {
    const {
      metaData,
      setProductType,
      productType,
      setAsyncFetching,
      asyncSuccess,
      setDisqualification,
      onGraphError,
      graphError,
      graphMessage,
      onFieldChange,
      recordDisqualification,
      showManualAddress,
      enterAddressManually
    } = this.props;
    const { asyncFetching } = this.state;

    return (
      <React.Fragment>
        <FormRow
          content={metaData.form.content.productType}
          byline={metaData.form.content.productType.byline}
          rowMarginBottom={6}
        >
          <FieldArray
            name={metaData.form.fields.productType.name}
            render={arrayHelpers => (
              <RadioGroup
                name={metaData.form.fields.productType.name}
                options={metaData.form.fields.productType.options}
                arrayHelpers={arrayHelpers}
                HOCHandler={setProductType}
                onFieldChange={onFieldChange}
              />
            )}
          />
        </FormRow>

        <Address
          metaData={metaData}
          productType={productType}
          isValid={asyncSuccess}
          onFieldChange={onFieldChange}
          asyncFetching={asyncFetching}
          setAsyncFetching={setAsyncFetching}
          graphQuery={CHECK_SERVICEABILITY}
          graphError={graphError}
          graphMessage={graphMessage}
          onGraphError={onGraphError}
          showManualAddress={showManualAddress}
          enterAddressManually={enterAddressManually}
          disqualificationMessage={metaData.form.content.disqualification}
          setDisqualification={setDisqualification}
          recordDisqualification={recordDisqualification}
        />

        {productType !== 'BATTERY' && (
          <React.Fragment>
            <FormRow
              content={metaData.form.content.propertyType}
              byline={metaData.form.content.propertyType.byline}
              rowMarginBottom={6}
            >
              <FieldArray
                name={metaData.form.fields.propertyType.name}
                render={arrayHelpers => (
                  <QualifyingRadioGroup
                    name={metaData.form.fields.propertyType.name}
                    options={metaData.form.fields.propertyType.options}
                    arrayHelpers={arrayHelpers}
                    onFieldChange={onFieldChange}
                    recordDisqualification={recordDisqualification}
                    disqualificationMessage={metaData.form.content.disqualification}
                    maxWidth={300}
                  />
                )}
              />
            </FormRow>

            <FormRow
              content={metaData.form.content.roofType}
              byline={metaData.form.content.roofType.byline}
              rowMarginBottom={6}
            >
              <FieldArray
                name={metaData.form.fields.roofType.name}
                render={arrayHelpers => (
                  <QualifyingRadioImageGroupField
                    name={metaData.form.fields.roofType.name}
                    options={metaData.form.fields.roofType.options}
                    arrayHelpers={arrayHelpers}
                    onFieldChange={onFieldChange}
                    recordDisqualification={recordDisqualification}
                    disqualificationMessage={metaData.form.content.disqualification}
                  />
                )}
              />
            </FormRow>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export { StepOne as default };
